module.exports = __webpack_public_path__ + "img/perez2.4f11039a.png";